// The Portal Insights guide (22_PortalInsights.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'Usage and Quotes',
  tabsB: 'Usage shows who uses the portal and how much; Quotes holds the quotes shown on the home page. You only see the tabs your role allows.',
  rangeT: 'Pick the period',
  rangeB: 'Set the dates, or use a preset for the last 7, 30 or 90 days. Refresh reloads the numbers and CSV saves the list.',
  tilesT: 'Headline numbers',
  tilesB: 'The tiles at the top sum up the tab you are on: on Usage, accounts, accounts that used the portal, accounts that did not, visits and time; on Quotes, the counts by status.',
  usageT: 'Who used the portal',
  usageB: 'One row per account with visits, time, active days and last seen. Click a column title to sort, and open a row to see where that person spent the time.',
  quoteFiltersT: 'Filter the quotes',
  quoteFiltersB: 'Show only the quotes in one status, or for one audience: the portal home page or the developer page.',
  quoteListT: 'The quotes',
  quoteListB: 'Each quote with its status and where it is shown. Approve or reject pending ones, edit the text, or add your own with the add button.',
};
const ko = {
  tabsT: '사용 현황과 명언',
  tabsB: '사용 현황은 누가 포털을 얼마나 쓰는지, 명언은 홈 화면에 나오는 문구를 보여 줍니다. 역할에 허용된 탭만 보입니다.',
  rangeT: '기간 선택',
  rangeB: '날짜를 직접 정하거나 최근 7일·30일·90일 프리셋을 쓰세요. 새로고침은 수치를 다시 불러오고 CSV는 목록을 저장합니다.',
  tilesT: '주요 수치',
  tilesB: '위쪽 타일은 현재 탭을 요약합니다. 사용 현황에서는 계정 수, 사용한 계정, 사용하지 않은 계정, 방문 수, 시간이, 명언에서는 상태별 건수가 나옵니다.',
  usageT: '누가 포털을 썼는지',
  usageB: '계정당 한 행에 방문 수, 시간, 활동 일수, 마지막 접속이 표시됩니다. 열 제목을 클릭해 정렬하고, 행을 열면 그 사람이 시간을 쓴 곳을 볼 수 있습니다.',
  quoteFiltersT: '명언 필터',
  quoteFiltersB: '상태별로, 또는 대상별(포털 홈 또는 개발자 화면)로 명언을 골라 볼 수 있습니다.',
  quoteListT: '명언 목록',
  quoteListB: '명언마다 상태와 표시 위치가 나옵니다. 대기 중인 항목을 승인·반려하고, 문구를 수정하거나, 추가 버튼으로 직접 등록할 수 있습니다.',
};
const vi = {
  tabsT: 'Usage và Quotes',
  tabsB: 'Usage cho biết ai dùng portal và dùng nhiều đến đâu; Quotes là các câu trích dẫn hiện trên trang chủ. Bạn chỉ thấy những tab mà role của bạn cho phép.',
  rangeT: 'Chọn khoảng thời gian',
  rangeB: 'Đặt ngày, hoặc dùng nút chọn nhanh 7, 30, 90 ngày gần nhất. Làm mới tải lại số liệu và CSV lưu danh sách.',
  tilesT: 'Các con số chính',
  tilesB: 'Các ô ở trên tóm tắt tab đang xem: ở Usage là số tài khoản, số đã dùng portal, số chưa dùng, lượt truy cập và thời gian; ở Quotes là số lượng theo trạng thái.',
  usageT: 'Ai đã dùng portal',
  usageB: 'Mỗi dòng là một tài khoản với lượt truy cập, thời gian, số ngày hoạt động và lần cuối vào. Bấm tiêu đề cột để sắp xếp, mở dòng để xem người đó dành thời gian ở đâu.',
  quoteFiltersT: 'Lọc câu trích dẫn',
  quoteFiltersB: 'Chỉ xem các câu ở một trạng thái, hoặc cho một đối tượng: trang chủ portal hay trang developer.',
  quoteListT: 'Danh sách câu trích dẫn',
  quoteListB: 'Mỗi câu kèm trạng thái và nơi hiển thị. Duyệt hoặc từ chối các câu đang chờ, sửa nội dung, hoặc thêm câu của bạn bằng nút thêm.',
};
const zh = {
  tabsT: 'Usage 和 Quotes',
  tabsB: 'Usage 显示谁在使用门户以及使用量；Quotes 是首页展示的名言。你只能看到角色允许的标签页。',
  rangeT: '选择时间段',
  rangeB: '可自行设定日期，或用最近 7 天、30 天、90 天的预设。刷新会重新加载数据，CSV 用于保存列表。',
  tilesT: '关键数字',
  tilesB: '顶部的卡片汇总当前标签页：Usage 显示账号数、使用过门户的账号、没用过的账号、访问次数和时长；Quotes 显示各状态的数量。',
  usageT: '谁用了门户',
  usageB: '每个账号一行，显示访问次数、时长、活跃天数和最近访问。点击列标题排序，展开一行可看到此人把时间花在哪里。',
  quoteFiltersT: '筛选名言',
  quoteFiltersB: '只看某个状态的名言，或只看某个对象：门户首页或开发者页面。',
  quoteListT: '名言列表',
  quoteListB: '每条名言显示状态和展示位置。可以批准或驳回待审的名言、修改文字，或用添加按钮新增。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "tabsT": "Utilisation et citations",
  "tabsB": "Utilisation montre qui utilise le portail et dans quelle mesure ; Citation du jour contient les citations affichées sur la page d'accueil. Vous ne voyez que les onglets autorisés par votre rôle.",
  "rangeT": "Choisir la période",
  "rangeB": "Définissez les dates, ou utilisez un préréglage pour les 7, 30 ou 90 derniers jours. Actualiser recharge les chiffres et CSV enregistre la liste.",
  "tilesT": "Chiffres clés",
  "tilesB": "Les tuiles du haut résument l'onglet affiché : sur Utilisation, les comptes, ceux qui ont utilisé le portail, ceux qui ne l'ont pas utilisé, les visites et le temps ; sur Citation du jour, le nombre par statut.",
  "usageT": "Qui a utilisé le portail",
  "usageB": "Une ligne par compte avec les visites, le temps, les jours actifs et la dernière connexion. Cliquez sur un titre de colonne pour trier, et ouvrez une ligne pour voir où cette personne a passé son temps.",
  "quoteFiltersT": "Filtrer les citations",
  "quoteFiltersB": "N'affichez que les citations d'un statut, ou d'un public : la page d'accueil du portail ou la page développeur.",
  "quoteListT": "Les citations",
  "quoteListB": "Chaque citation avec son statut et l'endroit où elle est affichée. Approuvez ou rejetez celles en attente, modifiez le texte, ou ajoutez la vôtre avec le bouton d'ajout."
};
const ja = {
  "tabsT": "利用状況と名言",
  "tabsB": "「利用状況」は誰がどれだけポータルを使っているかを表示し、「今日の一言」はホームページに表示する名言を管理します。ロールで許可されているタブのみ表示されます。",
  "rangeT": "期間を選択",
  "rangeB": "日付を設定するか、直近7日、30日、90日のプリセットを使います。「更新」で数字を再読み込みし、「CSV」でリストを保存します。",
  "tilesT": "主要な数字",
  "tilesB": "上部のタイルは、開いているタブの集計です。「利用状況」ではアカウント数、ポータルを利用したアカウント、利用していないアカウント、訪問数、時間を、「今日の一言」ではステータス別の件数を表示します。",
  "usageT": "ポータルの利用者",
  "usageB": "アカウントごとに1行で、訪問数、時間、利用日数、最終利用日を表示します。列見出しをクリックして並べ替え、行を開くとその人がどこで時間を使ったかを確認できます。",
  "quoteFiltersT": "名言を絞り込む",
  "quoteFiltersB": "1つのステータス、または1つの対象（ポータルのホームページまたは開発者ページ）の名言のみ表示します。",
  "quoteListT": "名言",
  "quoteListB": "各名言のステータスと表示場所を表示します。承認待ちのものは承認または却下でき、テキストの編集や、追加ボタンでの新規追加もできます。"
};

const dictionary = { ns: 'tourInsights', en, ko, vi, zh, fr, ja };
export default dictionary;
